import React, { useEffect, useRef } from 'react';
import cx from 'classnames';

import { NoSearchResults } from 'components/search/results';
import Spinner from 'components/Spinner';
import IconButton from 'components/IconButton';
import { useGlobalSearchData } from 'lib/providers/GlobalSearchDataProvider';

import styles from './OpportunityContentLayout.module.scss';

const OpportunityContentLayout: React.FC = ({ children }) => {
  const [child1, child2] = React.Children.toArray(children);
  const {
    isOpportunitiesLoading,
    noOpportunities,
    hasPreviousOpportunity,
    hasNextOpportunity,
    handleNextOpportunity,
    handlePreviousOpportunity,
    hasMoreOpportunities,
    nextOpportunityPage,
    isSelectedOpportunityLoading,
  } = useGlobalSearchData();
  const listRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (listRef.current && isOpportunitiesLoading) {
      listRef.current.scrollTo({ top: 0 });
    }
  }, [isOpportunitiesLoading, listRef]);

  useEffect(() => {
    if (!hasNextOpportunity && !isOpportunitiesLoading && hasMoreOpportunities) {
      nextOpportunityPage();
    }
  }, [hasNextOpportunity, hasMoreOpportunities, isOpportunitiesLoading]);

  return (
    <section className={styles.container}>
      {noOpportunities ? (
        <NoSearchResults />
      ) : (
        <>
          {hasPreviousOpportunity && (
            <IconButton
              iconName="icon_arrow-backward"
              size="medium"
              className={cx(styles.chevron, styles['chevron-left'])}
              disabled={isOpportunitiesLoading || isSelectedOpportunityLoading}
              onClick={handlePreviousOpportunity}
            />
          )}
          <aside className={styles['list-container']} ref={listRef}>
            {child1}
          </aside>
          <main className={styles.main}>{child2 ? child2 : <Spinner wrapperClassname={styles['spinner-container']} />}</main>
          {hasNextOpportunity && (
            <IconButton
              iconName="icon_arrow-forward"
              size="medium"
              className={cx(styles.chevron, styles['chevron-right'])}
              disabled={isOpportunitiesLoading || isSelectedOpportunityLoading}
              onClick={handleNextOpportunity}
            />
          )}
        </>
      )}
    </section>
  );
};

OpportunityContentLayout.displayName = 'OpportunityContentLayout';

export default OpportunityContentLayout;
